module.exports = __webpack_public_path__ + "img/SBB P DTZ S-Bahn Zue Richterswil.e3f20527.jpg";